/** @format */
import { request, getEnvUrlByUrl } from '@power/runtime-vue3';
import { isImageTypeResPath } from '@power/utils';
import type { BaseResponse } from '@power/runtime-vue3';
import * as V1 from '@/api/version-v1';

export function getBaseInfo(
	params: API.BaseInfoParams = {
		_t: new Date().getTime(),
	},
) {
	return request<BaseResponse<API.BaseInfoResult>>(
		{
			url: 'base/info',
			method: 'get',
			params,
		},
		{
			isMock: true,
		},
	);
}

// 文件上传
export function uploadFile(file, alias) {
	if ('V1' === window.pData.env.VITE_ENV_APP_BASE_API_VERSION) {
		return V1.uploadFile(file, alias);
	}
	const data = new FormData(); // 创建form对象
	data.append('file', file);
	data.append('folderAlias', alias);
	data.append('groupKey', '');
	return request<BaseResponse<API.BaseSystemResult>>({
		url: '/base/oss/file/upload',
		method: 'post',
		timeout: 0,
		data,
	});
}
// 系统附件删除
export function remove(data) {
	return request<BaseResponse<API.BaseSystemResult>>({
		url: '/base/oss/resource/delete',
		method: 'post',
		data,
	});
}
// 文件上传 按照id查询
export function resource(id) {
	return request<BaseResponse<any>>(
		{
			url: `base/oss/resource/getById/${id}`,
			method: 'get',
		},
		{
			isGetDataDirectly: false,
		},
	);
}
// 上传图片组件-获取图片列表
export function getImagesFileList(data) {
	return request<BaseResponse<API.BaseSystemResult>>({
		url: '/base/oss/file/images',
		method: 'post',
		data,
	});
}
// 上传附件组件-获取附件列表
export function getAnnexFileList(data) {
	return request<BaseResponse<API.BaseSystemResult>>({
		url: '/base/oss/file/fileList',
		method: 'post',
		data,
	});
}

/**
 * 上传视频组件-获取附件列表
 * 兼容V1和V2的方法
 * @param params {ids:'xxx,xxx'}
 */
export async function getFilesByIds(params) {
	const { ids } = params;
	if (!ids) {
		return [];
	} else {
		if (ids.indexOf('/static') > -1) {
			// V1
			return ids.split(',').map((item) => {
				let resType = '';
				if (isImageTypeResPath(item)) {
					resType = 'img';
				} else {
					resType = 'video';
				}
				return {
					version: 'V1',
					name: item,
					url: item,
					resType,
				};
			});
		} else {
			// V2
			let newIds = ids;
			if (ids.indexOf(getEnvUrlByUrl(`power-api/base/oss/file/download?id=`)) > -1) {
				// V2 老数据兼容处理
				newIds = ids.replaceAll(getEnvUrlByUrl(`power-api/base/oss/file/download?id=`), '');
			}
			if (ids.indexOf(getEnvUrlByUrl(`power-api/base/oss/file/preview?attachmentId=`)) > -1) {
				// V2 老数据兼容处理
				newIds = ids.replaceAll(getEnvUrlByUrl(`power-api/base/oss/file/preview?attachmentId=`), '');
			}
			const res: any = await request<BaseResponse>({
				url: '/base/oss/file/getFiles',
				method: 'get',
				params: {
					ids: newIds,
				},
			});
			return res.reverse().map((item) => {
				// const { id, resourceExtend, resourceName, resourceSize } = item;
				const { id, resourceName } = item;
				let resType = '';
				if (isImageTypeResPath(resourceName)) {
					resType = 'img';
				} else {
					resType = 'video';
				}
				return {
					version: 'V2',
					name: resourceName,
					url: id,
					resType,
				};
			});
		}
	}
}
